import React, { FC, ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { AuthHeader } from 'page-components';

interface Props {
  children: ReactNode;
  childrenClassName?: string;
  customHeader?: ReactNode;
}

const AuthLayout: FC<Props> = ({ children, childrenClassName, customHeader }) => {
  return (
    <div className='min-h-screen px-4 md:px-20 bg-dots bg-no-repeat	bg-right-bottom'>
      {customHeader || <AuthHeader />}
      <div className={twMerge('max-w-[576px] mx-auto w-full py-6 sm:pb-10', childrenClassName)}>{children}</div>
    </div>
  );
};

export default AuthLayout;
